<div class="body-2 p-6 bg-primary text-primary-contrast">
  <p>امروزز</p>
  <div class="display-1">{{ dayName }}</div>
  <div class="display-1">{{ date }}</div>
</div>

<mat-divider></mat-divider>

<mat-nav-list>
  <h3 matSubheader>رویدادهای آینده</h3>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>نشست کسب و کار</h4>
    <p matListItemLine>در 16 دقیقه، اتاق جلسه</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>درخواست تعطیلات کنید</h4>
    <p matListItemLine>12:00 بعد از ظهر</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>شام با سوفی</h4>
    <p matListItemLine>6:30 بعد از ظهر</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>آخرین مهلت پروژه X</h4>
    <p matListItemLine>9:00 بعد از ظهر</p>
  </a>
  <mat-divider></mat-divider>
  <h3 matSubheader>لیست  انجام کار</h3>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>جک را به بازی گلف دعوت کنید</h4>
    <p matListItemLine>اضافه شده: 6 ساعت پیش</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>Angular را بیشتر بشناسید</h4>
    <p matListItemLine>اضافه شده: 2 روز پیش</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle> روتر جدید را پیکربندی کنید</h4>
    <p matListItemLine>اضافه شده: 5 روز پیش</p>
  </a>
  <mat-divider></mat-divider>
  <h3 matSubheader>آمار سرور</h3>
</mat-nav-list>

<div class="vex-list-item" matRipple>
  <p>بار CPU (71٪ / 100٪)</p>
  <p class="progress-bar">
    <mat-progress-bar [value]="71" color="primary" mode="determinate"></mat-progress-bar>
  </p>
</div>

<div class="vex-list-item" matRipple>
  <p>استفاده از رم (6175 مگابایت / 16384 مگابایت)</p>
  <p class="progress-bar">
    <mat-progress-bar [value]="34" color="accent" mode="determinate"></mat-progress-bar>
  </p>
</div>

<div class="vex-list-item" matRipple>
  <p>دمای CPU (43 درجه / 80 درجه)</p>
  <p class="progress-bar">
    <mat-progress-bar [value]="54" color="warn" mode="determinate"></mat-progress-bar>
  </p>
</div>
